import * as React from 'react';

function MaintenanceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.18 8.002c0-.406.16-.795.443-1.085l.005-.006L15.75 4.79a4.05 4.05 0 0 0-3.634 1.38 4.05 4.05 0 0 0-.61 4.299.75.75 0 0 1-.152.84l-6.328 6.326a.95.95 0 0 0 0 1.339.946.946 0 0 0 1.338 0l6.327-6.326.088-.076a.75.75 0 0 1 .751-.078 4.05 4.05 0 0 0 4.3-.61 4.05 4.05 0 0 0 1.241-1.89 4 4 0 0 0 .138-1.743l-2.127 2.127a1.55 1.55 0 0 1-2.17 0l-.006-.005-1.284-1.285a1.55 1.55 0 0 1-.443-1.085m1.514.035 1.269 1.269a.05.05 0 0 0 .035.014.05.05 0 0 0 .035-.014l2.477-2.477c.59-.593 1.767-.497 2.042.505l.09.384a5.55 5.55 0 0 1-4.66 6.58 5.55 5.55 0 0 1-2.575-.246l-5.981 5.981a2.45 2.45 0 0 1-3.46 0 2.45 2.45 0 0 1 0-3.46l5.982-5.982a5.55 5.55 0 0 1-.246-2.572 5.55 5.55 0 0 1 6.965-4.57h-.001c1.004.275 1.097 1.45.509 2.04l-2.48 2.478-.015.035q0 .02.014.035"
  }));
}

export { MaintenanceIcon };
